import jQuery from 'jquery';
import 'isotope-packery';
import 'isotope-cells-by-row';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';
import Splide from '@splidejs/splide';

let teaserSplide;
//const customAnmation = new CustomAnimation();

class BlogArticle {

  // Hauptinitialisierung
  init() {
    this.initPage();
    this.initTeaserCaroussel();
    this.initParallax();
    this.onScroll();
  }

  // Hintergrund und Header konfigurieren
  initPage = () => {

    const imageContainer = document.querySelector(".blog_article_content_image");
    const img = imageContainer ? imageContainer.querySelector("img") : null;

    // Prüfen, ob das src leer oder ein Platzhalter ist
    if (img && (img.getAttribute("src") === "" || img.src.includes("xxxHTMLLINKxxx"))) {
      imageContainer.style.display = "none"; // Verstecke das div
    }
  };

  // Teaser-Karussell initialisieren
  initTeaserCaroussel = () => {
    const slideCount = document.querySelectorAll('.splide_teaser .splide__slide').length;

    teaserSplide = new Splide('.splide_teaser', {
      type: 'loop',
      perPage: 3,
      focus: 0,
      autoplay: false,
      flickMaxPages: 3,
      updateOnMove: true,
      pagination: true,
      throttle: 300,
      gap: slideCount === 3 ? '2rem' : 0,
      padding: slideCount === 3 ? 0 : undefined,
      breakpoints: {
        991: {
          perPage: 2,
          focus: false,
          gap: '1rem',
          padding: 0,
        },
        768: {
          perPage: 1,
        },
      },
    });
    teaserSplide.on('move', function () {
      // Zusätzliche Bewegungsevents, falls benötigt
    });
    teaserSplide.mount();
    requestAnimationFrame(() => {
      teaserSplide.refresh();
    });

    if (slideCount === 3) {
      document.querySelector('.blog_teaser_box_holder').classList.add('has-three-slides');
    }

    setTimeout(() => {
      //teaserSplide.refresh();
    }, 500);
  };

  // Parallax beim Scrollen konfigurieren
  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    /*
    const tableOfContent = document.querySelector(".table_of_content");

    // Breite dynamisch berechnen
    const setToCBounds = () => {
      const bounds = tableOfContent.getBoundingClientRect();
      tableOfContent.style.width = `${bounds.width}px`;
    };


    // Sticky mit GSAP ScrollTrigger aktivieren
    gsap.to(".table_of_content", {
      scrollTrigger: {
        trigger: ".blog_detail_content_right", // Bereich, in dem die Scrollüberwachung beginnt
        start: "top top+=200px", // Trigger startet bei 200px
        end: "bottom bottom", // Ende des Sticky-Effekts
        markers: true,
        onEnter: () => {
          setToCBounds(); // Breite des Elements berechnen
          tableOfContent.classList.add("sticky");
        },
        onLeaveBack: () => {
          tableOfContent.style.width = ""; // Zurücksetzen
          tableOfContent.classList.remove("sticky");
        },
        onUpdate: () => {
          setToCBounds(); // Die Breite dynamisch bei Änderungen garantieren
        },

      },
    });

     */

  };


  onScroll = () => {
    jQuery(window)
      .scroll(function () {

      }).scroll();
  };
}

export default BlogArticle;
